<template>
  <div class="notification-group">
    <b-notification
        :closable=false
        type="alert-block"
        message="Your financing Page hasn't been created yet.
          Please create it to get things going."
    />
    <div class="notification-group-set-up-group">
      <router-link v-if="userAuthenticator(CO_BRANDED_PAGE_ACCESS)" :to="{ name: 'co-branded' }"
                   class="notification-group-ref">GET STARTED
      </router-link>
    </div>
  </div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
  name: 'NotificationFinancingPage',
  props: {
    isDanger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      CO_BRANDED_PAGE_ACCESS: { resource: 'co-branded', code: 'access' },
    };
  },
  computed: {
    ...mapGetters(['userAuthenticator']),
  },
};
</script>

<style scoped lang="stylus">
.notification-group
  display flex
  align-items baseline
.notification-group-ref
  padding-right 10px
  color #525F66
  font-weight bold
  position relative
.notification-group-ref::before
  content url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='14' cy='14' r='13.5' fill='white' stroke='%23525F66'/%3E%3Cpath d='M20.3536 14.3536C20.5488 14.1583 20.5488 13.8417 20.3536 13.6464L17.1716 10.4645C16.9763 10.2692 16.6597 10.2692 16.4645 10.4645C16.2692 10.6597 16.2692 10.9763 16.4645 11.1716L19.2929 14L16.4645 16.8284C16.2692 17.0237 16.2692 17.3403 16.4645 17.5355C16.6597 17.7308 16.9763 17.7308 17.1716 17.5355L20.3536 14.3536ZM7 14.5H20V13.5H7V14.5Z' fill='%23525F66'/%3E%3C/svg%3E")
  position absolute
  top -5px
  left 100px
.notification-group-ref:hover::before
  content url("data:image/svg+xml,%3Csvg width='28' height='28' viewBox='0 0 28 28' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='14' cy='14' r='13.5' fill='%23525F66' stroke='%23525F66'/%3E%3Cpath d='M20.3536 14.3536C20.5488 14.1583 20.5488 13.8417 20.3536 13.6464L17.1716 10.4645C16.9763 10.2692 16.6597 10.2692 16.4645 10.4645C16.2692 10.6597 16.2692 10.9763 16.4645 11.1716L19.2929 14L16.4645 16.8284C16.2692 17.0237 16.2692 17.3403 16.4645 17.5355C16.6597 17.7308 16.9763 17.7308 17.1716 17.5355L20.3536 14.3536ZM7 14.5H20V13.5H7V14.5Z' fill='white'/%3E%3C/svg%3E")
.notification-group-set-up-group
  min-width 120px
</style>
